export default __webpack_public_path__ + "static/media/Tia_Fagan_AHV_In_Moms_We_Trust.0770c906.jpg";